(() => {
	angular.module('main').directive('trialBanner', trialBanner);

	trialBanner.$inject = ['accountService'];

	function trialBanner(accountService) {
		return {
			restrict: 'E',
			replace: true,
			scope: false,
			template: require('./trial-banner.component.html'),
			link(scope) {
				scope.unsubscribe = new Rx.Subject();

				getUser();

				scope.$on('$destroy', () => {
					scope.unsubscribe.next();
					scope.unsubscribe.complete();
				});

				function getUser() {
					accountService.userDataObservable.subscribe(user => {
						// do not add checking if user is not null because it makes subscription banner show up for logged out users
						if (typeof user !== 'undefined') {
							scope.user = user;

							if (user !== null && !user.admin) {
								checkGracePeriodAccess();
							}
						}
					});
				}

				function checkGracePeriodAccess() {
					scope.gracePeriodEnabled =
						scope.user.subscription.plan === 'UNPAID' &&
						scope.user.subscription.freeDaysAccess > 0;
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Subscription/trial-banner/trial-banner.component.js